export { default as signCertificataController } from './sign.certificata.controller';
